import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const DunningDetails = React.lazy(() => import('@/modules/dunning/components/detail/dunning-detail'))
const TransactionSendEmail = React.lazy(() => import('@/modules/transaction/components/email/transaction-send-email'))

const dunningRoutes = (
  <>
    <Route path='dunning/*' element={<RedirectToPlural />} />
    <Route path='dunnings/:invoiceId/:id' Component={DunningDetails} />
    <Route path='dunnings/send/:invoiceId/:id' Component={TransactionSendEmail} handle={{options: {noBackgroundColor: true}}} />
  </>
)

export default dunningRoutes
